import { Status } from '../models/status.interfaces';

export const DiamondMedallionBannerStatusMocks: Status = {
  priority: {
    active: false,
    label: '',
    url: ''
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DIAMOND MEDALLION®',
    level: '0',
    name: 'diamond'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const DiamondMedallionBannerWithSkyPriorityStatusMocks: Status = {
  priority: {
    active: true,
    label: 'SKY PRIORITY',
    url: '/us/en/check-in-security/sky-priority'
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'DIAMOND MEDALLION®',
    level: '0',
    name: 'diamond'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const DiamondMedallionBannerStatusWithLifetimeMocks: Status = {
  priority: {
    active: false,
    label: '',
    url: ''
  },
  tier: {
    title: '',
    subtitle: '',
    level: '0',
    name: 'diamond'
  },
  enrollDate: 'SKYMILES MEMBER SINCE 2004'
};

export const DiamondMedallionBannerWithSkyPriorityStatusWithLifetimeMocks: Status =
  {
    priority: {
      active: true,
      label: 'SKY PRIORITY',
      url: '/us/en/check-in-security/sky-priority'
    },
    tier: {
      title: '',
      subtitle: '',
      level: '0',
      name: 'diamond'
    },
    enrollDate: 'SKYMILES MEMBER SINCE 2004'
  };
